import { toast } from "react-toastify";
import BillsRepository from "../../Repository/BillsRepository";
import DefaultRepository from "../../Repository/DefaultRepository";
import LedgersRepository from "../../Repository/LedgersRepository";
import NotificationRepository from "../../Repository/NotificationRepository";
import SalesRepository from "../../Repository/SalesRepository";
import { unSaleItems } from "../inventory/itemsSlice";

export const P1 = (saveSales) => {
  return SalesRepository.salesModel({
    request: {
      method: "saveSale",
      data: {
        sales: saveSales,
      },
    },
  });
};

export const P2 = (ledgerHistories) => {
  return LedgersRepository.ledgerModel({
    request: {
      method: "saveLedgerHistory",
      data: {
        ledger_histories: ledgerHistories,
      },
    },
  });
};

export const P3 = (updatedItems) => {
  console.log('updatedItems', updatedItems)
  let tokenType = localStorage.getItem("tokenType");
  let userId = "";
  if (tokenType == "admin") {
    userId = localStorage.getItem("companyCode");
  } else {
    userId = localStorage.getItem("companyId");
  }
  
  return DefaultRepository.defaultModel({
    request: {
      method: "updateItem",
      data: {
        items: updatedItems,
        action: "Sold",
        user: userId,
      },
    },
  });
};
export const P4 = (noti) => {
  return NotificationRepository.notificationsModel({
    request: {
      method: "saveNotification",
      data: {
        notifications: noti,
      },
    },
  });
};

export const getBill = () => {
  return BillsRepository.billsModel({
    request: {
      method: "getBillNumber",
      data: {
        company_code: localStorage.getItem("companyCode"),
      },
    },
  });
};
export const getBillNumber = async () => {
  let { data } = await BillsRepository.billsModel({
    request: {
      method: "getBillNumber",
      data: {
        company_code: localStorage.getItem("companyCode"),
      },
    },
  });
  return data.response.data.newBillNumber;
};

export const getWarehouse = () => {
  return BillsRepository.warehousebillsModel({
    request: {
      method: "getWarehouseBills",
      data: {
        company_code: localStorage.getItem("companyCode"),
        next_page_token: "",
      },
    },
  });
};

export const saleWarhouse = async (bill, items, date) => {
  let { data } = await BillsRepository.warehousebillsModel({
    request: {
      method: "saveWarehouseBill",
      data: {
        company_code: localStorage.getItem("companyCode"),
        billNumber: bill,
        quantity: items,
        customerName: "",
        date: date,
      },
    },
  });
  if (data.response.status.statusCode == 200) {
    toast.configure();
    toast.success("Warehouse Created");
  } else {
    toast.configure();
    toast.error("Warehouse Not Created");
  }
};

export const mutateItems = async (items, dispatch, oldItems) => {
  let { data } = await DefaultRepository.defaultModel({
    request: {
      method: "updateItem",
      data: {
        items: items,
        action: "Sold",
        user: localStorage.getItem("token"),
      },
    },
  });
  if (data.response.status.statusCode == 200) {
  } else {
    dispatch(unSaleItems(oldItems));
  }
};
